import {UploaderComponent} from '../uploader';
import {takeUntil} from 'rxjs/operators';
import {NzModalService, NzNotificationService} from 'ng-zorro-antd';
import {Subject, combineLatest} from 'rxjs';
import {FormBuilder, FormGroup, Validators} from '@angular/forms';
import {DomSanitizer} from '@angular/platform-browser';
import {RootService} from '../../services';

export class HandleVideo {
  constructor( public modalService: NzModalService,
               public fb: FormBuilder,
               public sanitizer: DomSanitizer,
               public modal: NzModalService,
               public notification: NzNotificationService,
               public rootService: RootService,
               ) {
    this.setupAddressValidation();
  }
  addressDisplay: string = '';
  form_step1: FormGroup = this.fb.group({
    name: [null, [Validators.required, Validators.maxLength(255)]],
    tax_code: [
      null,
      [
        Validators.required,
        Validators.maxLength(255),
      ],
    ],
    country_id: [null, [Validators.required]],
    address: [null, [Validators.maxLength(255)]],
    addressNewName: [null, [Validators.maxLength(255)]],
    province_id: [null],
    provinceNewId: [null],
    district_id: [null],
    wardNewId: [null],
    streetId: [null],
    introImage: [null],
    addressNew: [false],
    introVideo: [null],
    intro: [null],
    phone: [null, [Validators.pattern('^[0-9]*$')]],
    email: [
      null,
      [
        Validators.pattern(
          '[a-zA-Z0-9.-_]{1,}@[a-zA-Z.-]{2,}[.]{1}[a-zA-Z]{2,}'
        ),
      ],
    ],
    website: [
      null,
      // [Validators.pattern('[a-zA-Z0-9]+[.]{1}[a-zA-Z]{0,}[.]?[a-zA-Z]+')],
    ],
    avatar: [null],
    background: [null],
    title: [null, [Validators.required]],
    role: [null, [Validators.required]],
  });
  unsubscribe$ = new Subject<void>();
  avatar: any[] = [];
  background: any[] = [];
  introImage: any[] = [];
  introVideo: any[] = [];

  setupAddressValidation() {
    // Theo dõi thay đổi của addressNew
    this.form_step1.get('addressNew').valueChanges
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(addressNew => {
        console.log('addressNew hẹ hẹ', addressNew);
        this.updateAddressValidation(addressNew);
      });

    // Chỉ log khi cả 3 giá trị province_id, district_id, address đều có
    combineLatest([
      this.form_step1.get('province_id').valueChanges,
      this.form_step1.get('district_id').valueChanges,
      this.form_step1.get('streetId').valueChanges,
      this.form_step1.get('address').valueChanges,
    ])
      .pipe(takeUntil(this.unsubscribe$))
      .subscribe(([provinceId, districtId, streetId, address]) => {
        if (provinceId && districtId && address && streetId) {
          // console.log('tuannguyenhung');
          const query = {
            type: 1,
            parentId: 0,
            cityOldId: provinceId,
            wardOldId: streetId
          };
          // console.log("address", address)
          this.rootService.getLocationOld(query).subscribe(res => {
            // console.log("res", res)
            if (res.code === 1 && res.data && res.data.cityNew && res.data.cityNew.name) {
              this.addressDisplay = [
                address,
                res && res.data && res.data.wardNew && res.data.wardNew.name,
                res && res.data && res.data.cityNew && res.data.cityNew.name
              ]
                .filter(function (item) {
                  return item; // loại bỏ undefined, null, ''
                })
                .join(', ');
            }
          });
        } else {
          this.addressDisplay = '';
        }
      });

    // Gọi lần đầu để set validation ban đầu
    this.updateAddressValidation(this.form_step1.get('addressNew').value);
  }

  updateAddressValidation(addressNew: boolean) {
    if (addressNew) {
      // Khi addressNew = true: bỏ required cho province_id, district_id, streetId, address
      this.form_step1.get('province_id').clearValidators();
      this.form_step1.get('district_id').clearValidators();
      this.form_step1.get('streetId').clearValidators();
      this.form_step1.get('address').clearValidators();

      // Thêm required cho addressNewName, provinceNewId, wardNewId
      this.form_step1.get('addressNewName').setValidators([Validators.required, Validators.maxLength(255)]);
      this.form_step1.get('provinceNewId').setValidators([Validators.required]);
      this.form_step1.get('wardNewId').setValidators([Validators.required]);
    } else {
      // Khi addressNew = false: thêm required cho province_id, district_id, streetId, address
      this.form_step1.get('province_id').setValidators([Validators.required]);
      this.form_step1.get('district_id').setValidators([Validators.required]);
      this.form_step1.get('streetId').setValidators([Validators.required]);
      this.form_step1.get('address').setValidators([Validators.required, Validators.maxLength(255)]);

      // Bỏ required cho addressNewName, provinceNewId, wardNewId
      this.form_step1.get('addressNewName').clearValidators();
      this.form_step1.get('provinceNewId').clearValidators();
      this.form_step1.get('wardNewId').clearValidators();
    }

    // Cập nhật validation cho tất cả các field
    this.form_step1.get('province_id').updateValueAndValidity();
    this.form_step1.get('district_id').updateValueAndValidity();
    this.form_step1.get('streetId').updateValueAndValidity();
    this.form_step1.get('address').updateValueAndValidity();
    this.form_step1.get('addressNewName').updateValueAndValidity();
    this.form_step1.get('provinceNewId').updateValueAndValidity();
    this.form_step1.get('wardNewId').updateValueAndValidity();
  }
  openUploadDialog(field: string) {
    const fileType = 'jpg,jpeg,png,gif,bmp';

    const modal = this.modalService.create({
      nzTitle: `Upload ${field}`,
      nzContent: UploaderComponent,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          switch (field) {
            case 'avatar' : {
              this.form_step1.get('avatar').setValue(changeParam.file.response.url);
              this.avatar = [{url: changeParam.file.response.url}];
            }               break;
            case 'background': {
              this.form_step1.get('background').setValue(changeParam.file.response.url);
              this.background = [{url: changeParam.file.response.url}];
            }                  break;
            case 'introImage': {
              this.form_step1.get('introImage').setValue(changeParam.file.response.url);
              this.introImage.push({url: changeParam.file.response.url}) ;
              if (this.introImage.length > 9) {
                this.introImage.pop();
                this.notification.create(
                  'warning',
                  'Cảnh báo',
                  'Chỉ hỗ trợ tối đa 9 ảnh'
                );
              }
            }                  break;
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(_ => {
          modal.close();
        });
    });
  }
  openUploadDialogVid() {
    const fileType = 'mp4';
    const modal = this.modal.create({
      nzTitle: `Tải Video lên`,
      nzContent: UploaderComponent,
      nzFooter: null,
      nzComponentParams: {
        fileExt: fileType,
        multiple: true,
      },
    });
    modal.afterOpen.pipe(takeUntil(this.unsubscribe$)).subscribe(() => {
      modal.getContentComponent().change.subscribe((changeParam) => {
        if (changeParam.type === 'success') {
          const tmpUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
            changeParam.file.response.url
          );
          // @ts-ignore
          this.introVideo.push(tmpUrl.changingThisBreaksApplicationSecurity);
          if (this.introVideo.length > 9) {
            this.introVideo.pop();
            this.notification.create(
              'warning',
              'Cảnh báo',
              'Chỉ hỗ trợ tối đa 9 video'
            );
          }
          const urlVideos = this.introVideo.map(
            (gg) => gg.changingThisBreaksApplicationSecurity
          );

          if (this.introVideo && this.introVideo.length) {
            this.form_step1.get('introVideo').setValue(urlVideos);
          }
        }
      });
      modal
        .getContentComponent()
        .done.pipe(takeUntil(this.unsubscribe$))
        .subscribe(() => {
          modal.close();
        });
    });
  }

  onRemoveFileAll(field: string) {

    switch (field) {
      case 'avatar': {
        this.avatar = [];
        this.form_step1.get('avatar').setValue(null);
      }              break;
      case 'background': {
        this.background = [];
        this.form_step1.get('background').setValue(null);
      }                  break;
      case'introImage': {
        this.introImage = [];
        this.form_step1.get('introImage').setValue(null);
      }
    }
  }


  clearVideoUrl(index: number) {
    this.introVideo.splice(index, 1);
    const urlVideos = this.introVideo.map(
      (gg) => gg.changingThisBreaksApplicationSecurity
    );
    this.form_step1.get('media').setValue(urlVideos);
  }



  onRemoveFile(field: string, index: number) {

    // dùng cho nhiều ảnh
    this[field].splice(index, 1);
    this.form_step1.get(field).value.splice(index, 1);
  }

}
